import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { t } from '../../services/i18nService';
import fileDeliveryService from '../../services/FileDeliveryService';
import navigationService from '../../services/NavigationService';
import apiTools from '../../services/api/ApiTools';
import sessionReader from '../../store/readHelpers/SessionReader';
import storeManager from '../../store/StoreManager';
import sessionActions from '../../actions/SessionActions';
import styles from './options.scss';

import OptionsTopBar from './OptionsTopBar';
import OptionsGroup from './OptionsGroup';
import Confirmation from './Confirmation';
import FileDeliveryButton from './optionButtons/FileDeliveryButton';
import FileDeliveryLink from './optionButtons/FileDeliveryLink';

const InvigilatorOptions = ({ isInvigilatorAuthorized, ui }) => {
    const setInvigilatorAuthorisation = () => {
        storeManager.dispatch(sessionActions.toggleInvigilatorAuthorized(true));
    };

    const saveAsFile = () => {
        const fileContents = fileDeliveryService.getEncryptedFileContent(false);
        fileDeliveryService.saveDelivery(fileContents);

        if (sessionReader.isOfflineMode()) {
            const componentKey = apiTools.getOfflineDeliveryLocalStorageKey();
            localStorage.setItem(componentKey, 'delivered');
            navigationService.navigateToFileDelivered();
        }
    };

    const FileDeliveryOption = () => {
        return fileDeliveryService.browserRequireBlobForLink() ?
            <FileDeliveryLink key="file_delivery_link" /> :
            <FileDeliveryButton key="file_delivery_button" clickHandler={saveAsFile} />;
    };

    const OptionList = (showFileDelivery) => {
        const list = [];
        const mainList = [];
        if (sessionReader.testUsesInvigilatorPassword()) {
            if (showFileDelivery) {
                mainList.push(<FileDeliveryOption key="fileDeliveryOptionButton" />);
            }
        }
        const mainGroup = <OptionsGroup buttons={mainList} key="optionGroupMainList" />;
        list.push(mainGroup);

        return list;
    };

    return (
        <div>
            <OptionsTopBar title={t('options.invigilatorOptionsHeader')} showOptionsButton showExitButton />
            <div className={styles.mainContentArea} role="main">
                {
                    isInvigilatorAuthorized ?
                        <OptionList showFileDelivery={ui.variables.options__moveFileDeliveryToInvigilator} /> :
                        <Confirmation
                            mainButtonText={t('general.continue')}
                            actionHandler={setInvigilatorAuthorisation}
                            requireInvigilatorPassword={sessionReader.testUsesInvigilatorPassword()}
                        />
                }
            </div>
        </div>
    );
};

InvigilatorOptions.propTypes = {
    isInvigilatorAuthorized: PropTypes.bool.isRequired,
    ui: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        currentlyShown: state.currentlyShown,
        isOnline: state.api.isOnline,
        isInvigilatorAuthorized: state.session.invigilatorAuthorized,
        ui: state.ui,
    };
}

const InvigilatorOptionsList = connect(mapStateToProps)(InvigilatorOptions);
export default InvigilatorOptionsList;
